import { render, staticRenderFns } from "./TreatmentPaidOnlineTimelineSection.vue?vue&type=template&id=09634194&scoped=true"
import script from "./TreatmentPaidOnlineTimelineSection.vue?vue&type=script&lang=js"
export * from "./TreatmentPaidOnlineTimelineSection.vue?vue&type=script&lang=js"
import style0 from "./TreatmentPaidOnlineTimelineSection.vue?vue&type=style&index=0&id=09634194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09634194",
  null
  
)

export default component.exports